import { Fragment } from "react";
import { Outlet, Route } from "react-router";
import { SuppliersList } from "./SupplierList";
import { CreateSupplierPage } from "./SupplierForm/CreateSupplier";
import { UpdateSupplierPage } from "./SupplierForm/UpdateSupplier";
import { Slugs } from "src/context/ProtectedContext";
import { CREATE, MODIFY, SUPPLIER, VIEW, useFoodpilotContext } from "src/context/FoodpilotContext";
import { Forbiddenpage } from "src/components/PageState/ForbiddenPage";
import { RouteErrorPage } from "src/components/PageState/RouteErrorPage";

export const useSupplierRouter = () => {
    return (
        <Fragment>
            <Route path="suppliers" errorElement={<RouteErrorPage />}>
                <Route element={<SupplierActionProtection slug={VIEW} />}>
                    <Route index element={<SuppliersList />} />
                </Route>

                <Route path={"new"} element={<SupplierActionProtection slug={CREATE} />}>
                    <Route element={<CreateSupplierPage />}>
                        <Route index />
                        <Route path={":startingPageId"} />
                    </Route>
                </Route>
                <Route path=":supplierId">
                    <Route path={"edit"} element={<SupplierActionProtection slug={MODIFY} />}>
                        <Route element={<UpdateSupplierPage />}>
                            <Route index />
                            <Route path={":startingPageId"} />
                        </Route>
                    </Route>
                </Route>
            </Route>
        </Fragment>
    );
};

type SupplierActionProtectionProps = {
    slug: Slugs;
};
const SupplierActionProtection = (props: SupplierActionProtectionProps) => {
    const { slug } = props;
    const { canUser } = useFoodpilotContext();

    if (canUser(slug, SUPPLIER) === false) {
        return <Forbiddenpage />;
    }

    return <Outlet />;
};
